"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const MultiSelect_1 = __importDefault(require("../components/MultiSelect"));
const axios_1 = __importDefault(require("axios"));
const mobx_react_lite_1 = require("mobx-react-lite");
const SearchPage_1 = __importDefault(require("../states/SearchPage"));
const SearchPage_2 = __importDefault(require("../states/SearchPage"));
const SearchPage_3 = __importDefault(require("../states/SearchPage"));
const FilterState_1 = __importDefault(require("../components/FilterState"));
const SearchResultPageStore_1 = __importDefault(require("../states/SearchResultPageStore"));
const file_saver_1 = require("file-saver");
const XLSX = __importStar(require("xlsx"));
const react_spinner_material_1 = __importDefault(require("react-spinner-material"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const translate_1 = require("../helper/translate");
const Search = (0, mobx_react_lite_1.observer)(({ filters }) => {
    const [selectedFilters, setSelectedFilters] = (0, react_1.useState)(SearchPage_1.default.selectedFilters);
    const results = SearchPage_2.default.results;
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const resultsPerPage = 5; // Set this to how many results you want per page
    const totalResults = results.length;
    const totalPages = Math.ceil(totalResults / resultsPerPage);
    const tableRef = (0, react_1.useRef)(null);
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [sqlText, setSqlText] = (0, react_1.useState)('');
    const [isShowSQL, setIsShowSQL] = (0, react_1.useState)(false);
    const [showSummary, setShowSummary] = (0, react_1.useState)(false);
    const [summaryFilters, setSummaryFilters] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        if (tableRef.current) {
            window.scrollTo({
                top: tableRef.current.offsetTop + 100,
                behavior: "smooth",
            });
        }
    }, [currentPage]);
    const paginatedResults = results.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage);
    const handleCheckboxChange = (event) => {
        setIsShowSQL(event.target.checked);
        console.log("Checkbox state:", event.target.checked);
    };
    const handleSelectionChange = (0, react_1.useCallback)((selectedValues) => {
        setSelectedFilters(prevState => {
            let updatedFilters = Object.assign({}, prevState); // Create a new object
            Object.keys(selectedValues).forEach((key) => {
                updatedFilters = Object.assign(Object.assign({}, updatedFilters), { [key]: selectedValues[key] });
            });
            Object.keys(updatedFilters).forEach(key => {
                if (Array.isArray(updatedFilters[key]) && updatedFilters[key].length === 0) {
                    delete updatedFilters[key];
                }
            });
            SearchPage_1.default.selectedFilters = updatedFilters;
            return updatedFilters;
        });
    }, [filters]);
    const copyToClipboard = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(sqlText)
                .then(() => alert('Copied to clipboard!'))
                .catch(err => alert('Failed to copy text: ' + err));
        }
        else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = sqlText;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                alert('Copied to clipboard!');
            }
            catch (err) {
                alert('Failed to copy text: ' + err);
            }
            document.body.removeChild(textArea);
        }
    };
    function getCookie(name) {
        let cookieArray = document.cookie.split(';');
        let cookieValue = null;
        cookieArray.forEach(cookie => {
            let [cookieName, value] = cookie.trim().split('=');
            if (cookieName === name) {
                cookieValue = value;
            }
        });
        return cookieValue;
    }
    const rolesCookie = getCookie('roles');
    const textRoles = rolesCookie ? JSON.parse(rolesCookie) : [];
    const headers = {
        'Authorization': `Bearer ${SearchPage_3.default.bearer}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };
    const handleShowResults = (0, react_1.useCallback)(() => {
        setIsLoading(true);
        const areFiltersSelected = Object.keys(selectedFilters).length > 0;
        if (!areFiltersSelected) {
            SearchResultPageStore_1.default.setShowSummary(true);
            SearchResultPageStore_1.default.setSummaryFilters({});
        }
        else {
            let url = '/api/search/getResults';
            if (!SearchPage_3.default.bearer) {
                url = '/api/search/getResultsGuest';
            }
            axios_1.default.post(url, Object.assign(Object.assign({}, selectedFilters), { locale: SearchPage_3.default.locale, roles: rolesCookie }), { headers }).then((resp) => {
                SearchPage_1.default.setKpiMode(selectedFilters.kpis && selectedFilters.kpis.length === 1);
                SearchPage_1.default.setCountryMode(selectedFilters.countries && selectedFilters.countries.length === 1);
                SearchPage_1.default.setYearMode(selectedFilters.years && selectedFilters.years.length === 1);
                SearchPage_1.default.setResults(resp.data.data);
                setSqlText(resp.data.sql);
                let customFilters = JSON.parse(JSON.stringify(filters));
                Object.keys(selectedFilters).forEach(key => {
                    if (customFilters[key] && Array.isArray(customFilters[key].options)) {
                        const selectedOptions = selectedFilters[key];
                        customFilters[key].options = customFilters[key].options.filter(option => selectedOptions.includes(option.value));
                    }
                });
                SearchPage_1.default.filters = customFilters;
                const mergedFilters = Object.assign(Object.assign({}, SearchResultPageStore_1.default.summaryFilters), selectedFilters);
                SearchResultPageStore_1.default.setSummaryFilters(Object.assign({}, selectedFilters));
                SearchResultPageStore_1.default.setShowSummary(true);
                setIsLoading(false);
            }).catch(error => {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            });
        }
    }, [filters, selectedFilters]);
    console.log(filters);
    (0, react_1.useEffect)(() => {
        if (SearchPage_3.default.results.length === 0) {
            let selFilters = {};
            Object.entries(filters).forEach(([title, filterInfo]) => {
                const filteredOptions = filterInfo.options.filter((option) => option.isSelected === 1);
                if (filteredOptions.length > 0) {
                    selFilters[title] = filteredOptions.map((option) => option.value);
                }
            });
            SearchPage_1.default.selectedFilters = selFilters;
            setSelectedFilters(selFilters);
        }
    }, [filters]);
    const multiSelectList = (0, react_1.useMemo)(() => {
        return Object.entries(filters).map(([key, filter]) => ((0, jsx_runtime_1.jsx)(MultiSelect_1.default, { index: key, options: filter.options, onChange: handleSelectionChange, title: filter.title, defaultValue: filter.options.filter((option) => {
                if (selectedFilters[key]) {
                    const values = selectedFilters[key].map(opt => opt);
                    return values.includes(option.value);
                }
                else
                    return false;
            }) }, key)));
    }, [selectedFilters]);
    function handleDownloadExcel() {
        // Define the headers for the Excel file
        const headers = [
            { header: 'KPI YEAR', key: 'first_kpi_year', width: 30 },
            { header: 'KPI TITLE', key: 'title', width: 30 },
            { header: 'Status', key: 'status', width: 10 },
            { header: 'WCO Member', key: 'country', width: 20 },
            { header: 'WCO Region', key: 'region', width: 15 },
            { header: 'PRIMARY EXPECTED OUTCOME', key: 'expected_outcomes', width: 30 },
            { header: 'KPI RESULT', key: 'result', width: 20 },
            { header: 'DISAGGREGATION', key: 'disaggregation', width: 15 },
            { header: 'DISCLOSURE POLICY', key: 'disclosure_policy', width: 15 },
        ];
        // Convert results to a format suitable for Excel
        const data = results.map((result) => ({
            first_kpi_year: result.attributes.first_kpi_year.slice(0, 4),
            title: result.attributes.title,
            status: 'Published', // Assuming status is always 'Published'
            country: result.attributes.country_name,
            region: result.attributes.region_medium,
            expected_outcomes: result.attributes.expected_outcomes,
            result: `${result.attributes.result} ${result.attributes.results_unit}`,
            disaggregation: result.attributes.disaggregations_count,
            disclosure_policy: result.attributes.disclosure_policy,
        }));
        // Create a new workbook and a worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);
        // Apply headers to worksheet
        XLSX.utils.sheet_add_aoa(worksheet, [headers.map(header => header.header)], { origin: 'A1' });
        headers.forEach((header, index) => {
            worksheet[`${String.fromCharCode(65 + index)}1`].s = { bold: true };
        });
        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
        // Write workbook to a binary buffer
        const wbout = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });
        // Convert binary string to array buffer
        const buffer = s2ab(wbout);
        // Create a Blob object from array buffer
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let title = 'Public-';
        let textRoles = [];
        if (rolesCookie) {
            textRoles = JSON.parse(rolesCookie);
        }
        if (textRoles === null || textRoles === void 0 ? void 0 : textRoles.user_roles.admin) {
            title = 'Admin-';
        }
        else if (textRoles === null || textRoles === void 0 ? void 0 : textRoles.user_roles.ncp) {
            title = 'NCP-' + (textRoles === null || textRoles === void 0 ? void 0 : textRoles.country) + '-';
        }
        const formattedDate = new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        // Use FileSaver to save the file
        (0, file_saver_1.saveAs)(blob, 'Search-Results-' + title + formattedDate + '.xlsx');
    }
    // Utility to convert a binary string to an array buffer
    function s2ab(s) {
        const buffer = new ArrayBuffer(s.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buffer;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [isLoading && (0, jsx_runtime_1.jsx)("div", { className: "spinner-container", style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 2
                }, children: (0, jsx_runtime_1.jsx)(react_spinner_material_1.default, { color: "#189CD8", visible: true }) }), SearchPage_3.default.bearer && (textRoles === null || textRoles === void 0 ? void 0 : textRoles.user_roles.admin) &&
                (0, jsx_runtime_1.jsxs)("div", { className: "form-check mb-2", children: [(0, jsx_runtime_1.jsx)("input", { id: "show-sql-script", className: "form-check-input", type: "checkbox", checked: isShowSQL, onChange: handleCheckboxChange }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "show-sql-script", className: "form-check-label", style: { marginLeft: '3px' }, children: (0, translate_1.translate)("Show SQL Script") })] }), (0, jsx_runtime_1.jsx)("div", { className: "mb-1 grid grid-cols-4 gap-3", children: multiSelectList }), (sqlText.trim().length > 0 && isShowSQL) && (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("p", { style: { fontSize: '12px', backgroundColor: '#f2f2f2' }, children: [(0, jsx_runtime_1.jsxs)("button", { onClick: copyToClipboard, style: {
                                border: 'none',
                                borderRadius: '5px',
                                padding: '5px 10px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                position: 'relative',
                            }, title: "Copy to clipboard", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCopy, style: { fontSize: '18px' } }), " "] }), sqlText] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "py-1", children: [(0, jsx_runtime_1.jsx)("button", { onClick: handleShowResults, className: "btn btn-success", children: (0, translate_1.translate)("Show result") }), !!results.length && ((0, jsx_runtime_1.jsxs)("button", { onClick: handleDownloadExcel, className: "btn btn-success mx-1", children: [" ", (0, translate_1.translate)("Export excel")] }))] }), SearchResultPageStore_1.default.showSummary ? (SearchResultPageStore_1.default.showSummary && (Object.keys(SearchResultPageStore_1.default.summaryFilters).length > 0 ? ((0, jsx_runtime_1.jsx)(FilterState_1.default, { selectedFilters: SearchResultPageStore_1.default.summaryFilters, filters: SearchPage_2.default.filters })) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}` } })))) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}` } })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "shadow table-responsive border-b border-gray-200", children: [(0, jsx_runtime_1.jsxs)("table", { className: "min-w-full divide-y divide-gray-200 text-sm text-left rtl:text-right text-gray-500 border", children: [(0, jsx_runtime_1.jsx)("thead", { className: "text-xs text-gray-700 uppercase bg-gray-50 sticky top-0", children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("KPI YEAR") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("KPI TITLE") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("WCO MEMBER") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("WCO REGION") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("PRIMARY EXPECTED OUTCOME") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("KPI RESULT") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("DISAGGREGATION") }), (0, jsx_runtime_1.jsx)("th", { className: "text-sm text-center text-nowrap p-[0.5rem] border", children: (0, translate_1.translate)("DISCLOSURE POLICY") })] }) }), (0, jsx_runtime_1.jsx)("tbody", { ref: tableRef, className: "bg-white divide-y divide-gray-200 max-h-[750px] overflow-scroll", children: paginatedResults.map((result, index) => ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes.first_kpi_year.slice(0, 4) }), (0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes.title }), (0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes.country_name }), (0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes.region_medium }), (0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes.expected_outcomes }), (0, jsx_runtime_1.jsxs)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: [result.attributes.result, " ", result.attributes.results_unit] }), (0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes
                                                    .disaggregations_count }), (0, jsx_runtime_1.jsx)("td", { className: "text-gray-500 text-sm text-center border p-[0.5rem]", children: result.attributes
                                                    .disclosure_policy })] }, index))) })] }), !!paginatedResults.length && ((0, jsx_runtime_1.jsx)("nav", { className: "flex items-center flex-column flex-wrap md:flex-row justify-between py-1", "aria-label": "Table navigation", children: (0, jsx_runtime_1.jsxs)("ul", { className: "inline-flex -space-x-px rtl:space-x-reverse text-sm h-8", children: [(0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", { className: "flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 border border-gray-300 rounded-s-lg hover:bg-blue-200 hover:text-gray-700", onClick: () => handlePageChange(currentPage - 1), children: (0, translate_1.translate)("Previous") }) }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", { className: "flex items-center justify-center px-3 h-8 leading-tight text-gray-500 border border-gray-300 hover:bg-blue-200 hover:text-gray-700 " +
                                                (1 === currentPage
                                                    ? "bg-blue-200"
                                                    : ""), onClick: () => handlePageChange(1), children: "1" }) }), currentPage > 2 && totalPages > 3 && ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", { className: "flex items-center justify-center px-3 h-8 leading-tight text-gray-500", children: "..." }) })), totalPages > 2 &&
                                        currentPage !== 1 &&
                                        currentPage !== totalPages && ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", { className: "flex items-center justify-center px-3 h-8 leading-tight text-gray-500 border border-gray-300 bg-blue-200 hover:text-gray-700", onClick: () => handlePageChange(currentPage), children: currentPage }) })), currentPage < totalPages - 1 &&
                                        totalPages > 3 && ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", { className: "flex items-center justify-center px-3 h-8 leading-tight text-gray-500", children: "..." }) })), totalPages > 1 && ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", { className: "flex items-center justify-center px-3 h-8 leading-tight text-gray-500 border border-gray-300 hover:bg-blue-200 hover:text-gray-700 " +
                                                (totalPages === currentPage
                                                    ? "bg-blue-200"
                                                    : ""), onClick: () => handlePageChange(totalPages), children: totalPages }) })), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", { className: "flex items-center justify-center px-3 h-8 leading-tight text-gray-500 border border-gray-300 rounded-e-lg hover:bg-blue-200 hover:text-gray-700", onClick: () => handlePageChange(currentPage + 1), children: (0, translate_1.translate)("Next") }) })] }) }))] }) })] }));
});
exports.default = react_1.default.memo(Search);
